import { whiteListPlayersWithdrawalStore } from "../stores/whiteListPlayersWithdrawals";

import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { blackListWithdrawalsStore, } from "../stores/whiteListPlayersWithdrawals";
import { blackListWithdrawalsEditModalStore } from "../stores/whiteListPlayersWithdrawalsEditModal";
import { blackListWithdrawalsAddModalStore } from "../stores/whiteListPlayersWithdrawalsAddModal";
import { whiteListPlayersWithdrawalsAddModalStore } from "../stores/whiteListPlayersWithdrawalsAddModal";
import { whiteListPlayersWithdrawalsEditModalStore } from "../stores/whiteListPlayersWithdrawalsEditModal";
/* ------- */

class WhiteListPlayersWithdrawals extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadWhiteListPlayersWithdrawals();
	}


	deleteWhiteListPlayersWithdrawal(id) {
		const data = {
			id,
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "whistListPlayersWithdrawal",
			method: "delete"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Delete " + id  + " was success");
			this.props.Interface.loadWhiteListPlayersWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setWhiteListPlayersWithdrawals({ ...this.props.whiteListPlayersWithdrawals, loaded: true, error });
		})
	}

	render() {
		return (
			<>
				{this.props.whiteListPlayersWithdrawals.loaded && this.props.whiteListPlayersWithdrawals.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.whiteListPlayersWithdrawals.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.whiteListPlayersWithdrawals.error.code} | request timestamp: {this.props.whiteListPlayersWithdrawals.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.whiteListPlayersWithdrawals.loaded}
					sortingColumn={{ sortingField: this.props.whiteListPlayersWithdrawals.sorting.sortingColumn.column }}
					sortingDescending={this.props.whiteListPlayersWithdrawals.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setWhiteListPlayersWithdrawals({ ...this.props.whiteListPlayersWithdrawals, sorting: {
								...this.props.whiteListPlayersWithdrawals.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadWhiteListPlayersWithdrawals();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, id: item.id, description: item.description, brand: this.props.whiteListPlayersWithdrawalsAddModal.currentOption.brand.filter((element) => element.value === item.brand)[0], uid: item.uid, show: true });
										}, 0);
									}}
									children={item.id}
								/>
							),
						},
						{ id: "uid", header: "UID", sortingField: "uid", cell: (item) => item.uid },
						{ id: "brand", header: "Brand", sortingField: "brand", cell: (item) => this.props.whiteListPlayersWithdrawalsAddModal.currentOption.brand.filter((element) => element.value === item.brand)[0].label },
						{ id: "description", header: "Description", sortingField: "description", cell: (item) => item.description },
						{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
						{ id: "action", header: "Action", cell: (item) => <><Button
								className={[this.props.styles["btnUID"], this.props.styles["red"]].join(" ")}
								variant="normal"
								onClick={() => {
									setTimeout(() => {
										this.deleteWhiteListPlayersWithdrawal(item.id);
									}, 0);
								}}
								children={"Delete"}
							/></> },
					]}
					items={this.props.whiteListPlayersWithdrawals.data}
					pagination={
						<Pagination
							disabled={!this.props.whiteListPlayersWithdrawals.loaded}
							currentPageIndex={this.props.whiteListPlayersWithdrawals.pagination.current}
							pagesCount={this.props.whiteListPlayersWithdrawals.pagination.total}
							onChange={(page) => {
								this.props.setWhiteListPlayersWithdrawals({ ...this.props.whiteListPlayersWithdrawals, pagination: { ...this.props.whiteListPlayersWithdrawals.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => this.props.Interface.loadWhiteListPlayersWithdrawals(), 250);
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.whiteListPlayersWithdrawals.preferences.perPage }}
							preferences={{ pageSize: this.props.config.whiteListPlayersWithdrawals.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("players.whiteListPlayersWithdrawals.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, whiteListPlayersWithdrawals: { ...this.props.config.whiteListPlayersWithdrawals, perPage: preferences.detail.pageSize } });

								setTimeout(() => this.props.Interface.loadWhiteListPlayersWithdrawals(), 250);
							}}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="White players list withdrawals"
									counter={
										<>
											(
											{
												this.props.whiteListPlayersWithdrawals.pagination.count
											}
											)
										</>
									}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												iconName="add-plus"
												disabled={!this.props.whiteListPlayersWithdrawals.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													setTimeout(() => {
														this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, show: true });
													}, 0);
												}}
												variant="primary"
												children="Create white list withdrawal"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>
					}
					empty="No white list players withdrawals found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const whiteListPlayersWithdrawals = useRecoilValue(whiteListPlayersWithdrawalStore);
		const setWhiteListPlayersWithdrawals = useSetRecoilState(whiteListPlayersWithdrawalStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const whiteListPlayersWithdrawalsAddModal = useRecoilValue(whiteListPlayersWithdrawalsAddModalStore);
		const setWhiteListPlayersWithdrawalsAddModal = useSetRecoilState(whiteListPlayersWithdrawalsAddModalStore);

		const whiteListPlayersWithdrawalsEditModal = useRecoilValue(whiteListPlayersWithdrawalsEditModalStore);
		const setWhiteListPlayersWithdrawalsEditModal = useSetRecoilState(whiteListPlayersWithdrawalsEditModalStore);

		return <Component {...props} whiteListPlayersWithdrawalsEditModal={whiteListPlayersWithdrawalsEditModal} setWhiteListPlayersWithdrawalsEditModal={setWhiteListPlayersWithdrawalsEditModal} whiteListPlayersWithdrawals={whiteListPlayersWithdrawals} setWhiteListPlayersWithdrawals={setWhiteListPlayersWithdrawals} config={config} setConfig={setConfig} whiteListPlayersWithdrawalsAddModal={whiteListPlayersWithdrawalsAddModal} setWhiteListPlayersWithdrawalsAddModal={setWhiteListPlayersWithdrawalsAddModal} />;
	};
}

export default withRecoil(WhiteListPlayersWithdrawals);
